import { TileView } from './TileView';

export default TileView;
